<template>
  <div
    class="circular-view-wrap"
    style="padding-top:40%">
    <div
      v-if="list.length === 0"
      class="image-slot">
      <i
        class="el-icon-picture-outline"
        style="font-size:40px;"></i>
    </div>
    <el-carousel
      v-else
      class="el-carousel-fix">
      <el-carousel-item
        v-for="(item,index) in newList"
        :key="index">
        <el-image
          style="width: 100%; height: 100%"
          :src="item.image"
          fit="cover"></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
// const png1 = require('../image/t1/1.png')
// const png2 = require('../image/t2/1.png')
// const png3 = require('../image/t3/1.png')
export default {
  name: 'WeCircularView',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      // png1,
      // png2,
      // png3
    }
  },
  computed: {
    newList() {
      return this.list.map(i => {
        return {
          ...i,
          image: i.image[0] ? i.image[0].url : ''
        }
      })
    }
    // png() {
    //   return ({
    //     1: this.png1,
    //     2: this.png2,
    //     3: this.png3
    //   })[this.templateId]
    // }
  }
}
</script>
<style lang="stylus">
.circular-view-wrap {
  position: relative;

  .image-slot {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
  }

  .el-carousel-fix {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    .el-carousel__container {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
